const i18n = require('./dist/i18n');

module.exports = i18n;


